<template>
  <div class="page" v-if="$conFun.clientWidth() > 768">
    <Nav isActive="1" :isIndex="isIndex" />
    <div style="position: relative">
      <div class="swipermask">
        <div class="pageWD">
          <div class="pnames">云学科技——数智营销服务专家</div>
        </div>
      </div>
      <el-carousel
        indicator-position="inside"
        :height="height"
        style="text-align: center"
      >
        <el-carousel-item v-for="(item, index) in swiperList" :key="index">
          <img :src="item.litpic" :style="{ height: height }" />
        </el-carousel-item>
      </el-carousel>
    </div>
    <div class="pageWD p100">
      <img
        src="../assets/images/s1.png"
        style="width: 160px; height: 96px; margin-bottom: 40px"
      />
      <div class="flex-sb">
        <img
          src="../assets/images/pp.png"
          style="width: 600px; height: 332px"
        />
        <div style="padding: 50px 0 0 50px">
          <div class="f24 dark">数智营销服务专家</div>
          <div class="f16 c6" style="line-height: 30px; margin: 30px 0">
            数字经济浪潮下，云学科技专注为企业提供数智营销服务，提供覆盖公域私域，线上线下的全场景数智化营销平台，通过数智化改造，代运营服务，助力企业转型升级。
          </div>
          <img
            src="../assets/images/r.png"
            style="width: 32px; height: 32px"
            @click="tapMe('/about')"
          />
        </div>
      </div>
    </div>
    <div class="section2">
      <div
        class="pageWD flex-sb"
        style="align-items: center; padding: 30px 0 10px 0"
      >
        <div>
          <div style="font-size: 47px; color: #ffffff">
            云学科技可以改变什么？
          </div>
          <div style="color: #89a1ad; font-size: 33px">
            What can yunxue technology change?
          </div>
          <div class="homebtn" @click="showDown = true">查看案例详情</div>
        </div>
        <div class="">
          <div class="clist" v-for="(item, index) in clist" :key="index">
            <img :src="item.pic" style="width: 399px; height: 148px" />
            <div
              class="f29"
              style="line-height: 28px; padding: 15px 20px; color: #474747"
            >
              {{ item.text }}
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="pageWD" style="padding-top: 100px">
      <img src="../assets/images/s2.png" style="width: 240px; height: 96px" />
      <div style="text-align: center; margin: 30px auto" class="f24 dark">
        课程介绍
      </div>
      <div class="flex-sb">
        <div v-for="(item, index) in courselist" class="kclist" :key="index">
          <img :src="item.imgUrl" style="width: 289px; height: 153px" />
          <div class="f16">{{ item.name }}</div>
          <div class="see f12 c6" @click="showDown = true">查看详情>></div>
        </div>
      </div>
      <div style="text-align: center; margin: 30px auto" class="f24 dark">
        服务介绍
      </div>
      <div class="flex-sb">
        <div v-for="(item, index) in fwlist" class="fwlist" :key="index">
          <img :src="item.imgUrl" style="height: 131px" />
          <div class="f16 nn" style="padding: 25px 0 10px 0">
            {{ item.name }}
          </div>
          <div class="f12 c6 sub sub1">{{ item.sub1 }}</div>
          <div class="f12 c6 sub sub2">{{ item.sub2 }}</div>
        </div>
      </div>
    </div>
    <div class="pageWD p100">
      <div class="flex-sb" style="align-items: flex-end; margin-bottom: 40px">
        <img src="../assets/images/s3.png" style="width: 160px; height: 78px" />
        <div class="f14" style="color: #656565" @click="tapMe('/news')">
          查看更多>>
        </div>
      </div>
      <div class="flex-sb">
        <img
          :src="artList[0].pic"
          style="width: 544px; height: 316px"
          @click="tapMeMO(artList[0])"
        />
        <div style="margin-left: 50px" v-if="artList">
          <div
            class="flex-sb newitem"
            v-for="(item, index) in artList"
            :key="index"
            @click="tapMeMO(item)"
            v-if="index < 2"
          >
            <div class="l">
              <div class="f30 c6">{{ item.CreatedOn.substr(5, 6) }}</div>
              <div class="f16" style="color: #ababab">
                {{ item.CreatedOn.substr(0, 4) }}
              </div>
            </div>
            <div style="flex: 1">
              <div class="f20 c6" style="margin-bottom: 12px; font-weight: 700">
                {{ item.ArtTitle }}
              </div>
              <div
                class="f14 c6"
                style="
                  line-height: 26px;
                  margin-bottom: 15px;
                  height: 55px;
                  overflow: hidden;
                "
              >
                {{ item.Content }}
              </div>
              <div class="f14 c6 more" style="text-align: right">
                查看详情>>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <showBox v-if="showDown" @hideMe="showDown = false" />
    <Fotter />
  </div>
  <div v-else>
    <Nav />
    <div class="mbpage">
      <div style="position: relative">
        <div class="swipermask" style="top: 30px">
          <div><div class="pnames_m">云学科技——数智营销服务专家</div></div>
        </div>
        <el-carousel indicator-position="inside" height="185px">
          <el-carousel-item v-for="item in swiperList" :key="item">
            <img :src="item.litpic" style="width: 100%; height: 185px" />
          </el-carousel-item>
        </el-carousel>
      </div>
      <div style="padding: 10px">
        <img
          src="../assets/images/s1.png"
          style="width: 80px; margin: 10px 0"
        />
        <div>
          <img src="../assets/images/pp.png" style="width: 100%" />
          <div style="padding-top: 20px">
            <div class="f24 dark">数智营销服务专家</div>
            <div class="f16 c6" style="line-height: 30px; margin: 20px 0">
              数字经济浪潮下，云学科技专注为企业提供数智营销服务，提供覆盖公域私域，线上线下的全场景数智化营销平台，通过数智化改造，代运营服务，助力企业转型升级。
            </div>
            <img
              src="../assets/images/r.png"
              style="width: 32px; height: 32px"
              @click="tapMe('/about')"
            />
          </div>
        </div>
      </div>
      <div class="section2" style="padding: 10px">
        <div style="align-items: center; padding: 30px 0 10px 0">
          <div>
            <div style="font-size: 24px; color: #ffffff">
              云学科技可以改变什么？
            </div>
            <div style="color: #89a1ad; font-size: 18px; margin-bottom: 20px">
              What can yunxue technology change?
            </div>
            <!-- <div class="homebtn" @click="showDown = true">查看案例详情</div> -->
          </div>
          <div class="">
            <div
              class="clist"
              v-for="(item, index) in clist"
              :key="index"
              style="width: 100%"
            >
              <img :src="item.pic" style="width: 100%" />
              <div
                class="f29"
                style="line-height: 28px; padding: 15px 20px; color: #474747"
              >
                {{ item.text }}
              </div>
            </div>
          </div>
        </div>
      </div>
      <div>
        <img
          src="../assets/images/s2.png"
          style="width: 170px; padding: 10px"
        />
        <div style="text-align: center; margin: 20px auto" class="f20 dark">
          课程介绍
        </div>
        <div class="flex-sb">
          <div
            v-for="(item, index) in courselist"
            class="kclist"
            :key="index"
            v-if="index < 2"
            style="padding: 10px"
          >
            <img :src="item.imgUrl" style="width: 100%" />
            <div class="f14" style="height: 50px">{{ item.name }}</div>
            <div class="see f12 c6" @click="showDown = true" style="margin: 0">
              查看详情>>
            </div>
          </div>
        </div>
        <div class="flex-sb">
          <div
            v-for="(item, index) in courselist"
            class="kclist"
            :key="index"
            v-if="index >= 2"
            style="padding: 10px"
          >
            <img :src="item.imgUrl" style="width: 100%" />
            <div class="f14" style="height: 50px">{{ item.name }}</div>
            <div class="see f12 c6" @click="showDown = true" style="margin: 0">
              查看详情>>
            </div>
          </div>
        </div>
        <div style="text-align: center; margin: 20px auto" class="f20 dark">
          服务介绍
        </div>
        <div class="flex-sb">
          <div
            v-for="(item, index) in fwlist"
            class="fwlist"
            :key="index"
            v-if="index < 2"
            style="margin: 10px"
          >
            <img :src="item.imgUrl" style="height: 80px" />
            <div class="f14 nn" style="padding: 10px 0 10px 0">
              {{ item.name }}
            </div>

            <div class="f12 c6 sub sub1" style="padding: 10px">
              {{ item.sub2 }}
            </div>
          </div>
        </div>
        <div class="flex-sb">
          <div
            v-for="(item, index) in fwlist"
            class="fwlist"
            :key="index"
            v-if="index >= 2"
            style="margin: 10px"
          >
            <img :src="item.imgUrl" style="height: 80px" />
            <div class="f14 nn" style="padding: 10px 0 10px 0">
              {{ item.name }}
            </div>

            <div class="f12 c6 sub sub1" style="padding: 10px">
              {{ item.sub2 }}
            </div>
          </div>
        </div>
      </div>
    <div style="padding:10px">
      <div class="flex-sb" style="align-items: flex-end; margin-bottom: 20px">
        <img src="../assets/images/s3.png" style="width:120px;" />
        <div class="f14" style="color: #656565" @click="tapMe('/news')">
          查看更多>>
        </div>
      </div>
      <div >
        <img
          :src="artList[0].pic"
          style="width: 100%; margin-bottom:20px"
          @click="tapMeMO(artList[0])"
        />
        <div v-if="artList">
          <div
            class="flex-sb newitem"
            v-for="(item, index) in artList"
            :key="index"
            @click="tapMeMO(item)"
            v-if="index < 2"
          >
            <div class="l">
              <div class="f30 c6">{{ item.CreatedOn.substr(5, 6) }}</div>
              <div class="f16" style="color: #ababab">
                {{ item.CreatedOn.substr(0, 4) }}
              </div>
            </div>
            <div style="flex: 1">
              <div class="f20 c6" style="margin-bottom: 12px; font-weight: 700">
                {{ item.ArtTitle }}
              </div>
              <div
                class="f14 c6"
                style="
                  line-height: 26px;
                  margin-bottom: 15px;
                  height: 55px;
                  overflow: hidden;
                "
              >
                {{ item.Content }}
              </div>
              <div class="f14 c6 more" style="text-align: right">
                查看详情>>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    </div>
    <Fotter />
  </div>
</template>
<script>
import { articleList } from "@/api/api";
import Nav from "../components/Nav.vue";
import Fotter from "../components/Fotter.vue";
import showBox from "../components/showBox.vue";
export default {
  name: "index",
  components: { Nav, Fotter, showBox },
  data() {
    return {
      showDown: false,
      fwlist: [
        {
          name: "企业转型陪跑",
          imgUrl: "http://h5.shihua.com/static/yunxue/p1.png",
          sub1: "整合企业、社会等多方资源，搭建平台，健全服务体系，推动集聚政策...",
          sub2: "整合企业、社会等多方资源，搭建平台，健全服务体系，推动集聚政策、技术、资本等要素，为企业开设转型陪跑通道，助推企业加速前进，创新数智化发展路径。",
        },
        {
          name: "创业创新孵化",
          imgUrl: "http://h5.shihua.com/static/yunxue/p2.png",
          sub1: "云学科技为创业者提供开放合作平台，充分发挥教育行业的资源优势，让...",
          sub2: "云学科技为创业者提供开放合作平台，充分发挥教育行业的资源优势，让广大企业和创业者相互学习合作，共同推进“双创”工作。提供创新孵化器团队和运作机制让每一个项目从0到1创新加速，探索可行模式到产品市场验证成型。",
        },
        {
          name: "代运营服务",
          imgUrl: "http://h5.shihua.com/static/yunxue/p3.png",
          sub1: "策划量身定制互动营销，专人专项策划实施，资深设计把控视觉，专业编...",
          sub2: "策划量身定制互动营销，专人专项策划实施，资深设计把控视觉，专业编辑操刀撰写，视觉统筹精致排版，热点内容专题系列，助力引流获客，场景内会员激活 ，广告平台精准投放。",
        },
        {
          name: "营销教育学院",
          imgUrl: "http://h5.shihua.com/static/yunxue/p4.png",
          sub1: "云学科技整合行业课程资源，搭建线上营销教育学院，汇集百位行业大咖导师...",
          sub2: "云学科技整合行业课程资源，搭建线上营销教育学院，汇集百位行业大咖导师，海量精品课程，覆盖全岗位需求，通过零距离授课讲解，满足移动化课程学习需求。",
        },
      ],
      courselist: [
        {
          name: "品牌与营销：从入门到精通",
          imgUrl: "http://h5.shihua.com/static/yunxue/c1.png",
          img: "",
        },
        {
          name: "怎么做社群微营销，才能激起千万量级传播？",
          imgUrl: "http://h5.shihua.com/static/yunxue/c2.png",
          img: "",
        },
        {
          name: "大神教你玩转微信营销，快速获取1000万粉丝",
          imgUrl: "http://h5.shihua.com/static/yunxue/c3.png",
          img: "",
        },
        {
          name: "简单9招，玩转社会化媒体营销",
          imgUrl: "http://h5.shihua.com/static/yunxue/c4.png",
          img: "",
        },
      ],
      artList: [],
      clist: [
        {
          pic: "http://h5.shihua.com/static/yunxue/a1.png",
          text: "餐饮行业 | 全年营收超60亿!揭秘某火锅店逆袭增长的运营之道",
        },
        {
          pic: "http://h5.shihua.com/static/yunxue/a2.png",
          text: "美妆行业 | 低代码全域客户数据采集，赋能数据化运营",
        },
      ],
      isIndex: 1,
      swiperList: [
        {
          litpic: "http://h5.shihua.com/static/yunxue/homepic.jpg",
        },
      ],
      height: null,
      heightNum: null,
    };
  },
  created() {
    var width = document.documentElement.clientWidth / 1920;
    this.height = 780 * width + "px";
    this.getList();
  },
  mounted() {
    window.scrollTo(0, 0);
    window.addEventListener("scroll", this.handleScroll);
  },
  methods: {
    tapMe(url) {
      this.$router.push({ path: url });
    },
    tapMeMO(item) {
      this.$router.push({ path: "/News/detail?id=" + item.ArtID });
    },
    getList() {
      var that = this;
      var data = {
        ArtColumn: "shihua",
        pageIndex: "1",
        pageSize: "10",
      };
      articleList(data).then((res) => {
        that.artList = res.body.result.forumList;
      });
    },
    // getSwiperList(typeid) {
    //   var that = this;
    //   var data = {
    //     typeid: typeid,
    //   };
    //   articleList(data).then((res) => {
    //     that.swiperList = res.data.list;
    //   });
    // },
    handleScroll() {
      var scrollTop =
        window.pageYOffset ||
        document.documentElement.scrollTop ||
        document.body.scrollTop;
      if (scrollTop > 150) {
        this.isIndex = 2;
      } else {
        this.isIndex = 1;
      }
    },
  },
};
</script>
<style scoped>
body {
  background: #fff;
}
>>> .el-carousel__container {
  height: auto;
}
.el-carousel__item h3 {
  color: #475669;
  font-size: 18px;
  opacity: 0.75;
  margin: 0;
}
.section2 {
  background: #12435a;
}
.clist {
  width: 399px;
  background: #fff;
  border-radius: 6px;
  margin-bottom: 20px;
}
.clist .f20 {
  color: #474747;
  font-weight: bold;
  padding: 20px 0 20px 35px;
  margin: 0 0 0 0;
  background: url("../assets/images/roll.png") no-repeat 15px;
}
.fwlist {
  width: 289px;
  height: 394px;
  background: #ffffff;
  border: 1px solid #25a2dd;
  border-radius: 6px;
  text-align: center;
}
.fwlist .sub {
  padding: 0 24px;
  line-height: 26px;
  position: relative;
  padding-top: 20px;
  margin-top: 10px;
}
.fwlist .sub::before {
  position: absolute;
  top: 0;
  left: 135px;
  width: 25px;
  height: 1px;
  background: #ccc;
  content: "";
}
.fwlist .nn {
  font-weight: 700;
}
.fwlist:hover {
  border-top: 5px solid #25a2dd;
  border-bottom: 5px solid #25a2dd;
  /* position: relative;
    top:-10px; */
  /* transform:translateY(-10px) */
  position: relative;
  animation: mymove 0.8s 1;
  -webkit-animation: mymove 0.8s 1; /*Safari and Chrome*/
  animation-iteration-count: 1;
  -webkit-animation-iteration-count: 1; /*Safari and Chrome*/
  animation-fill-mode: forwards;
  -webkit-animation-fill-mode: forwards;
}
.fwlist .sub2 {
  display: none;
}
.fwlist:hover .sub1 {
  display: none;
}
.fwlist:hover .sub2 {
  display: block;
}

.swipermask {
  position: absolute;
  z-index: 99;
  left: 0;
  right: 0;
  top: 180px;
  bottom: 0;
}
.pnames {
  text-align: left;
  font-size: 50px;
  color: #fff;
  z-index: 10000;
  padding-top: 100px;
}
.pnames_m {
  text-align: center;
  font-size: 20px;
  color: #fff;
  z-index: 10000;
  padding-top: 40px;
}
@keyframes mymove {
  from {
    top: 0px;
  }
  to {
    top: -10px;
  }
}
@-webkit-keyframes mymove /*Safari and Chrome*/ {
  from {
    top: 0px;
  }
  to {
    top: -10px;
  }
}
</style>


// WEBPACK FOOTER //
// src/views/index.vue